import useBrands from "../../explorer/hooks/useBrands";
import { useTranslation } from "../../explorer/hooks/useTranslation";
import { useReduxState } from "../../explorer/redux/hooks";
import { Basket } from "../../explorer/types";
import { BasketDetail } from "../../explorer/types/Basket/BasketDetail";
import { BasketItem } from "../../explorer/types/Basket/BasketItems";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";
import ServiceProvider from "../configuration/ServiceProvider";
import useGoToPage from "./useGoToPage";

export const useBasket: () => {
    // loadBaskets: () => void;
    renameBasket: (basketId: number, name: string) => any;
    createBasket: (name: string) => any;
    changeCurrentBasket: (basketId: number) => void;
    deleteBasket: (basketId: number) => any;
    currentBasket: Basket;
    reloadBaskets: (brand: string) => Basket[];
    saveCurrentBasket: (basketId: number) =>   Basket[];
} = () => {
    const [baskets, setBaskets] = useReduxState<Basket[]>(
        reduxStoreConfig.basketBaskets
    );

    const [currentBasket, setCurrentBasket] = useReduxState<Basket>(
        reduxStoreConfig.basketCurrentBasket
    );

    const goToPage = useGoToPage();
    const brand = useBrands().currentBrandUrl;
    const { t } = useTranslation();

    const getCurrentBasketFromList = (basketList: Basket[]) => {
        const selBasket = basketList?.find((x) => x.selected) ?? basketList[0];
        return {...selBasket};
    } 

    // const loadBaskets = () => {
    //     let data = [...baskets];
    //     if (data !== undefined && data.length > 0) {
    //         var selectedItem = data.find((x) => x.selected === true) ?? data[0];
    //         data.forEach(function (item, i) {
    //             if (selectedItem !== undefined && item.id === selectedItem.id) {
    //                 data.splice(i, 1);
    //                 data.unshift(item);
    //             }
    //         });
    //         setCurrentBasket({...selectedItem});
    //     }
    // };

    const renameBasket: any = async (basketId: number, name: string) => {
        if (name === null || name.trim() === "") {
            return false;
        }
        let message: string | undefined = undefined;
        const result: void | Basket[] = await ServiceProvider.Basket.renameBasket(
            brand,
            basketId,
            name
        ).catch(
            (reason: any) => {
                message = errorHandler(reason);
            }
        );
        if (basketId === currentBasket.id && result)
            setCurrentBasket(result.find((b) => b.id === basketId)!);
        return handleResults(result, message, "rename");
        // if (result !== null && result.length > 0) {
        //     setBaskets(result);
        // } else {
        //     return false;
        // }
    };

    const errorHandler = (reason: any) => {
        var errors = reason.data?.errors;
        let message =
            errors && errors instanceof Array
                ? errors
                      .map((e) =>
                          t(
                              `basket.validation.${e.propertyName}.${e.errorCode}`
                          )
                      )
                      .join(", ")
                : undefined;
        return message;
    }

    const handleResults = (result: any, message: string | undefined, operationName: string) => {
        if (result !== null && result instanceof Array && result.length > 0) {
            setBaskets(result);
            //const newBasket: Basket = result.find((x) => x.name === name)!;
            setCurrentBasket(getCurrentBasketFromList(result));
            return {
                open: true,
                isError: false,
                message: t(`basket.${operationName}.success`) as string,
                result: result,
                data: result,
            };
        } else {
            return {
                open: true,
                isError: true,
                message: message ?? t(`basket.${operationName}.error`),
            };
        }
    }

    // ---------------
    // Basket create
    // ---------------
    const createBasket: any = async (name: string) => {
        if (
            name === undefined ||
            name === null ||
            name.trim() === "" ||
            name.length > 100
        ) {
            return {
                open: true,
                isError: true,
                message: t("basket.validation.Name.empty"),
            };
        }

        let message: string | undefined = undefined;
        const result: void | Basket[] =
            await ServiceProvider.Basket.createBasket(brand, name).catch(
                (reason: any) => {
                    message = errorHandler(reason);
                }
            );
        return handleResults(result, message, "create");
        // if (result !== null && result instanceof Array && result.length > 0) {
        //     return {
        //         ..._ret,
        //         data: result,
        //     };
        // } else {
        //     return _ret;
        // }
        // if (result !== null && result instanceof Array && result.length > 0) {
        //     setBaskets(result);
        //     const newBasket: Basket = result.find((x) => x.name === name)!;
        //     return {
        //         open: true,
        //         isError: false,
        //         message: t("basket.create.success") as string,
        //         data: newBasket,
        //     };
        // } else {
        //     return {
        //         open: true,
        //         isError: true,
        //         message: message ?? t("basket.create.error"),
        //     };
        // }
    };

    // ---------------
    // Merge basket
    // ---------------
    const mergeBasket: any = async (basketId: number) => {
        const result: any = await ServiceProvider.Basket.mergeBasket(
            brand,
            basketId
        );
        if (result !== null && result.length > 0) {
            setBaskets(result);
            return true;
        } else {
            return false;
        }
    };

    // ---------------
    // Change current basket
    // ---------------
    const changeCurrentBasket: any = async (basketId: number) => {
        var newBasketSelected = baskets.find((x) => x.id === basketId);
        var oldBasketSelected = baskets.find((x) => x.selected);

        if (
            newBasketSelected !== undefined &&
            oldBasketSelected !== undefined
        ) {
            if (newBasketSelected.id === oldBasketSelected.id) {
                goToPage.system.goToBasket();
                return;
            }
        }
        /*
        if (basketId !== undefined && newBasketSelected !== undefined) {
            setCurrentBasket({...newBasketSelected});
            const result = await saveCurrentBasket(basketId);
            if (result) {
                setBaskets(result);
                goToPage.system.goToBasket();
            }
        }
            */
           if (basketId !== undefined ) {
              
               const result = await saveCurrentBasket(basketId);
               if (result) {
                    setBaskets(result);
                    var _newBasketSelected = result.find( (x:Basket) => x.id === basketId);
                    setCurrentBasket({ ..._newBasketSelected });
                   
                   goToPage.system.goToBasket();
               }
           }
    };

    //
    // Save to Db CurrentBasket
    //
    const saveCurrentBasket: any = async (basketId: number) => {
        return await ServiceProvider.Basket.setCurrentBasket(brand, basketId);
    };

    // ---------------
    // Basket delete
    // ---------------
    const deleteBasket: any = async (basketId: number) => {
        const result: any = await ServiceProvider.Basket.deleteBasket(
            brand,
            basketId
        );
        if (result !== null && result.length > 0) {
            setBaskets(result);
            return true;
        } else {
            return false;
        }
    };

    //
    // Reload Basket
    //
    const reloadBaskets: any = async (basketId: number) => {
        const result: Basket[] = await ServiceProvider.Basket.getBaskets(brand);
        setBaskets(result);
        const currBasket = getCurrentBasketFromList(result);
        if (currBasket?.id !== currentBasket?.id) {
            setCurrentBasket(getCurrentBasketFromList(result));
        }
        return result;
    };

    return {
        // loadBaskets,
        renameBasket,
        createBasket,
        changeCurrentBasket,
        deleteBasket,
        currentBasket,
        mergeBasket,
        reloadBaskets: reloadBaskets,
        saveCurrentBasket,
    };
};

